import { render, staticRenderFns } from "./question_point.vue?vue&type=template&id=e229df32&scoped=true&"
import script from "./question_point.vue?vue&type=script&lang=js&"
export * from "./question_point.vue?vue&type=script&lang=js&"
import style0 from "./question_point.vue?vue&type=style&index=0&id=e229df32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e229df32",
  null
  
)

export default component.exports